/* eslint-disable no-param-reassign */
import produce from 'immer';
import { SET_ALLDISPATCHWORKFLOWS } from 'src/actions/allDispatchWorkflowActions';

const initialState = {
  allDispatchWorkflows: null,
};

const allDispatchWorkflowsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALLDISPATCHWORKFLOWS: {
      let allDispatchWorkflows;
      if (action.payload?.allDispatchWorkflows) {
        allDispatchWorkflows = action.payload.allDispatchWorkflows;
      } else if (action.payload) {
        allDispatchWorkflows = action.payload;
      } else {
        allDispatchWorkflows = [];
      }

      return produce(state, (draft) => {
        draft.allDispatchWorkflows = allDispatchWorkflows;
      });
    }
    default: {
      return state;
    }
  }
};

export default allDispatchWorkflowsReducer;
